import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';
import { RootState } from '@global/store/store';

import {
  UPDATE_SHIPPING_INFO_DATA,
  UPDATE_SHIPPING_INFORMATION,
  UPDATE_SHIPPING_INFORMATION_RESPONSE,
  UPDATE_SHIPPING_INFORMATION_VARIABLES,
} from '@src/global/requests/checkout/UPDATE_SHIPPING_INFORMATION';
import { ShippingInfoFormValuesType } from '@src/pages/checkout/components/ShippingInformation/types';
import { mapShippingInfoToServer } from '@src/pages/checkout/components/ShippingInformation/utils';

export const updateShippingInformation = createAsyncThunk<
  UPDATE_SHIPPING_INFO_DATA,
  ShippingInfoFormValuesType,
  { rejectValue: string }
>(
  'cart/updateShippingInformation',
  async (shippingInfo, { rejectWithValue, getState }) => {
    try {
      const { cart } = getState() as RootState;

      const result = await client.mutate<
        UPDATE_SHIPPING_INFORMATION_RESPONSE,
        UPDATE_SHIPPING_INFORMATION_VARIABLES
      >({
        mutation: UPDATE_SHIPPING_INFORMATION,
        variables: {
          orderUid: cart.cartId,
          ...mapShippingInfoToServer(shippingInfo),
        },
      });

      return result.data.wUpdateShipping.result.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue('SERVER ERROR');
    }
  }
);
